import React, { Fragment } from 'react'

import styles from './cardPresenter.module.css'

import { Modal } from '../../molecules/modal'

export const CardPresenter = props => {
    return <Fragment>
        <div className={styles.mobiles}>
            <Modal close={props.modalClose} header={props.modalHeader}>{props.content}</Modal>
        </div>
        <div className={styles.screens}>
            <div className={styles.column}>
                <div className={styles.modalContainer}>
                    <div className={styles.modalHeader}>
                        <div className={styles.modalHeading}>
                            {props.modalHeader}
                        </div>
                        <label onClick={props.modalClose}>&times;</label>
                    </div>
                    <div className={styles.modalBody}>
                        {props.content}
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

// modalClose modalHeader content